<template>
  <div class="container">
    <div class="search-entry" @click="openSearchPopup">
      <div class="search-entry-main">
        <van-icon name="search" />
        <span class="search-entry-text">{{ searchDisplayText }}</span>
      </div>
      <span class="search-entry-action">
        {{ activeFilterCount > 0 ? `${activeFilterCount}项筛选` : '去筛选' }}
      </span>
    </div>

    <van-list v-model="loading" :finished="finished" @load="onLoad">
      <div v-for="item in $store.getters.infoList" :key="item.id">
        <div class="content-info">
          <div class="content-head">
            <van-image fit="cover" width="100%" height="100%" v-show="item.sex === 1"
              :src="item.avatarLink || defaultPhoto1" lazy-load />
            <van-image fit="cover" width="100%" height="100%" v-show="item.sex !== 1"
              :src="item.avatarLink || defaultPhoto0" lazy-load />
          </div>
          <div class="content-detail" @click="checkInfo(item)">
            <!-- <h6 class="detail-line1">{{ item.serialNumber }}号</h6> -->
            <div class="member-name">
              <span class="name">{{ item.nickName || formatSerial(item.serialNumber) }}</span>
              <span class="serial">ID:{{ formatSerial(item.serialNumber) }}</span>
            </div>
            <div class="detail-line2">
              <span>
                <span>性别:</span>
                <span>{{ item.sex === 1 ? '男' : '女' }}</span>
              </span>
              <span>
                <span>年纪:</span>
                <span>{{ getUpdateTime(item.birthday) }}</span>
              </span>
              <span>
                <span>身高:</span>
                <span>{{ item.height }}CM</span>
              </span>
            </div>
            <div class="detail-line3">
              <span class="detail-line3-hometown">
                <span>籍贯:</span>
                <span>{{ item.hometown }}</span>
              </span>
              <span class="detail-line3-education">
                <span>学历:</span>
                <span>{{ educationData[item.education - 1] }}</span>
              </span>
            </div>
          </div>
          <div class="content-go"><span v-if="[1, 2, 3].includes(item.followUpStatus)">ing</span></div>
        </div>
      </div>
    </van-list>

    <van-popup v-model="showSearchPopup" position="right" class="search-popup">
      <div class="search-popup-page">
        <div class="search-popup-header">
          <div class="popup-title">搜索筛选</div>
          <button class="popup-close" @click="showSearchPopup = false">✕</button>
        </div>

        <div class="search-popup-body">
          <div class="keyword-card">
            <div class="keyword-label">会员编号</div>
            <div class="keyword-field">
              <van-icon name="search" />
              <input v-model.trim="serialNumber" type="text" placeholder="输入会员编号/昵称">
            </div>
          </div>

          <div class="filter-section">
            <div class="section-title">基础筛选</div>
            <div class="selector-grid">
              <div class="selector-cell" @click="handleShowPicker('sex')">
                <span class="selector-label">性别</span>
                <span class="selector-value" :class="{ placeholder: !sex }">{{ sex || '不限' }}</span>
              </div>
              <div class="selector-cell" @click="handleShowPicker('education')">
                <span class="selector-label">学历</span>
                <span class="selector-value" :class="{ placeholder: !education }">{{ education || '不限' }}</span>
              </div>
              <div class="selector-cell" @click="handleShowPicker('start')">
                <span class="selector-label">出生年份最小值</span>
                <span class="selector-value" :class="{ placeholder: !minimumBirthday }">{{ minimumBirthday || '最小'
                }}</span>
              </div>
              <div class="selector-cell" @click="handleShowPicker('end')">
                <span class="selector-label">出生年份最大值</span>
                <span class="selector-value" :class="{ placeholder: !maximumBirthday }">{{ maximumBirthday || '最大'
                }}</span>
              </div>
              <div class="selector-cell" @click="handleShowPicker('minimumHeight')">
                <span class="selector-label">身高最小值</span>
                <span class="selector-value" :class="{ placeholder: !minimumHeight }">{{ minimumHeight || '最小' }}</span>
              </div>
              <div class="selector-cell" @click="handleShowPicker('maximumHeight')">
                <span class="selector-label">身高最大值</span>
                <span class="selector-value" :class="{ placeholder: !maximumHeight }">{{ maximumHeight || '最大' }}</span>
              </div>
              <div class="selector-cell" @click="areaCheck = true">
                <span class="selector-label">籍贯</span>
                <span class="selector-value over-omit" :class="{ placeholder: !hometown }">{{ hometown || '不限' }}</span>
              </div>
            </div>
          </div>

          <div class="filter-section">
            <div class="section-title">标签筛选</div>
            <div class="selector-grid">
              <div class="selector-cell" @click="showTagPicker('personality')">
                <span class="selector-label">性格标签</span>
                <span class="selector-value over-omit" :class="{ placeholder: !personalityTagsText }">
                  {{ personalityTagsText || "不限" }}
                </span>
              </div>
              <div class="selector-cell" @click="showTagPicker('spouse')">
                <span class="selector-label">择偶标签</span>
                <span class="selector-value over-omit" :class="{ placeholder: !spouseTagsText }">
                  {{ spouseTagsText || "不限" }}
                </span>
              </div>
            </div>
          </div>

        </div>

        <div class="search-popup-footer">
          <button class="footer-btn footer-btn-reset" @click="handleEmpty">重置</button>
          <button class="footer-btn footer-btn-confirm" @click="handlePopupQuery">确定筛选</button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showPicker" round position="bottom" :style="{ height: '40%' }" class="picker-popup">
      <van-picker :columns="columns" @cancel="onCancel" @confirm="onConfirm" :show-toolbar="true" />
    </van-popup>
    <van-popup v-model="areaCheck" position="bottom" :style="{ height: '50%' }" class="area-popup">
      <van-area v-model="hometowns" :area-list="areaData" :columns-num="areaNum" @cancel="hometownsCancel"
        @confirm="onFinish">
        <template #title>
          <span class="popup-area-title"><van-checkbox v-model="checked" shape="square"
              @change="changeChecked">精确到市</van-checkbox></span>
        </template>
      </van-area>
    </van-popup>

    <van-popup v-model="showTagPopup" position="bottom" :style="{ height: '60%' }">
      <div class="tag-picker">
        <div class="tag-picker-header">
          <span @click="cancelTags">取消</span>
          <span class="title">{{ tagPickerTitle }}</span>
          <span @click="confirmTags">确定</span>
        </div>
        <div class="tag-list">
          <span v-for="tag in currentTagList" :key="tag.id" class="tag-item"
            :class="{ selected: selectedTags.includes(tag.id) }" @click="toggleTag(tag)">{{ tag.tagName }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { areaList } from '@vant/area-data';
import { getMemberList, createBrowsingHistory, getAllTags } from '../../api/user';

export default {
  name: 'MemberQuery',
  data() {
    return {
      checked: this.$store.getters.queryPage.areaNum === 2,
      hometowns: '',
      showPicker: false,
      showSearchPopup: false,
      columns: [],
      highColumns: [],
      loading: false,
      finished: false,
      dateData: [],
      serialNumber: this.$store.getters.queryPage.serialNumber,
      minimumHeight: this.$store.getters.queryPage.minimumHeight,
      maximumHeight: this.$store.getters.queryPage.maximumHeight,
      minimumBirthday: this.$store.getters.queryPage.minimumBirthday,
      maximumBirthday: this.$store.getters.queryPage.maximumBirthday,
      personalityTagsText: '',
      spouseTagsText: '',
      currentTagList: [],
      currentTagType: "",
      selectedTags: [],
      showTagPopup: false,
      type: '',
      areaData: areaList,
      sex: this.$store.getters.queryPage.sex,
      education: this.$store.getters.queryPage.education,
      areaCheck: false,
      hometown: this.$store.getters.queryPage.hometown,
      educationData: [
        '大专', '本科', '硕士', '博士', '高中及以下'
      ],
      page: this.$store.getters.queryPage.page,
      pageSize: 10,
      areaNum: this.$store.getters.queryPage.areaNum,
      selectedPersonalityTags: [],
      selectedSpouseTags: [],
    };
  },
  computed: {
      educationFilterOptions() {
        return ['不限', '大专及以上', '本科及以上', '硕士及以上', '博士及以上'];
      },
    activeFilterCount() {
      const filters = [
        this.sex,
        this.education,
        this.minimumBirthday,
        this.maximumBirthday,
        this.minimumHeight,
        this.maximumHeight,
        this.hometown,
        this.serialNumber,
      ];
      return filters.filter(Boolean).length;
    },
    birthdaySummary() {
      if (!this.minimumBirthday && !this.maximumBirthday) {
        return '';
      }
      if (this.minimumBirthday && this.maximumBirthday) {
        return `${this.minimumBirthday}-${this.maximumBirthday}`;
      }
      return this.minimumBirthday ? `${this.minimumBirthday}后` : `${this.maximumBirthday}前`;
    },
    heightSummary() {
      if (!this.minimumHeight && !this.maximumHeight) {
        return '';
      }
      if (this.minimumHeight && this.maximumHeight) {
        return `${this.minimumHeight}-${this.maximumHeight}cm`;
      }
      return this.minimumHeight ? `${this.minimumHeight}cm+` : `${this.maximumHeight}cm内`;
    },
    searchDisplayText() {
      if (this.serialNumber) {
        return `编号 ${this.serialNumber}`;
      }
      const summaryList = [
        this.sex,
        this.education,
        this.hometown,
        this.birthdaySummary,
        this.heightSummary,
      ].filter(Boolean);
      if (summaryList.length) {
        return summaryList.slice(0, 2).join(' · ');
      }
      return '搜索会员编号/筛选条件';
    },
    tagPickerTitle() {
      switch (this.currentTagType) {
        case "personality":
          return "性格标签";
        case "spouse":
          return "择偶标签";
        default:
          return "选择标签";
      }
    },
  },
  methods: {
    openSearchPopup() {
      this.showSearchPopup = true;
    },
    changeChecked(value) {
      this.areaNum = value ? 2 : 1;
    },
    onConfirm(value) {
      this.showPicker = false;
      switch (this.type) {
        case 'sex':
          this.sex = value;
          break;
        case 'education':
          this.education = value;
          break;
        case 'minimumHeight':
          if (this.maximumHeight && this.maximumHeight < value) {
            this.minimumHeight = this.maximumHeight;
            this.maximumHeight = value;
            return;
          }
          this.minimumHeight = value;
          break;
        case 'maximumHeight':
          if (this.minimumHeight && this.minimumHeight > value) {
            this.maximumHeight = this.minimumHeight;
            this.minimumHeight = value;
            return;
          }
          this.maximumHeight = value;
          break;
        case 'start':
          if (this.maximumBirthday && this.maximumBirthday < value) {
            this.minimumBirthday = this.maximumBirthday;
            this.maximumBirthday = value;
            return;
          }
          this.minimumBirthday = value;
          break;
        case 'end':
          if (this.minimumBirthday && this.minimumBirthday > value) {
            this.maximumBirthday = this.minimumBirthday;
            this.minimumBirthday = value;
            return;
          }
          this.maximumBirthday = value;
          break;
        default:
          break;
      }
    },
    onCancel() {
      this.showPicker = false;
      switch (this.type) {
        case 'sex':
          this.sex = '';
          break;
        case 'education':
          this.education = '';
          break;
        case 'minimumHeight':
          this.minimumHeight = '';
          break;
        case 'maximumHeight':
          this.maximumHeight = '';
          break;
        case 'start':
          this.minimumBirthday = '';
          break;
        case 'end':
          this.maximumBirthday = '';
          break;
        default:
          break;
      }
    },
    hometownsCancel() {
      this.areaCheck = false;
      this.hometown = '';
    },
    handleShowPicker(type) {
      this.type = type;
      switch (type) {
        case 'sex':
          this.columns = ['男', '女'];
          break;
        case 'education':
          this.columns = ['不限', '大专及以上', '本科及以上', '硕士及以上', '博士及以上'];
          break;
        case 'minimumHeight':
        case 'maximumHeight':
          this.columns = this.highColumns;
          break;
        case 'start':
        case 'end':
          this.columns = this.dateData;
          break;
        default:
          break;
      }
      this.showPicker = true;
    },
    onFinish(value) {
      this.areaCheck = false;
      if (this.areaNum === 2) {
        this.hometown = value.map((option) => option && option.name).filter(Boolean).join('/');
      } else {
        this.hometown = value[0] ? value[0].name : '';
      }
    },
    handleEmpty() {
      const params = {
        sex: '',
        education: '',
        minimumBirthday: '',
        maximumBirthday: '',
        minimumHeight: '',
        maximumHeight: '',
        serialNumber: '',
        hometown: '',
        page: 1,
        areaNum: 1,
        personalityTagIds: [],
        spouseRequirementTagIds: [],
      }
      this.sex = '';
      this.education = '';
      this.minimumBirthday = '';
      this.maximumBirthday = '';
      this.minimumHeight = '';
      this.maximumHeight = '';
      this.serialNumber = '';
      this.hometown = '';
      this.page = 1;
      this.areaNum = 1;
      this.checked = false;
      this.selectedPersonalityTags = [];
      this.personalityTagsText = '';
      this.selectedSpouseTags = [];
      this.spouseTagsText = '';
      this.$store.dispatch('SET_QueryList', params);
    },
    checkInfo(item) {
      this.$router.push({ path: `/detailInformation/${item.id}` });
      this.$store.dispatch('SetQueryName', 'query');
      const browseTime = new Date().toISOString();
      const data = {
        baseMemberInfoId: this.$store.getters.baseInfo.id,
        browsedMemberInfoId: item.id,
        browseTime,
      };
      createBrowsingHistory(data);
    },
    onLoad() {
      const queryList = {
        sex: this.sex,
        education: this.education,
        minimumBirthday: this.minimumBirthday,
        maximumBirthday: this.maximumBirthday,
        minimumHeight: this.minimumHeight,
        maximumHeight: this.maximumHeight,
        hometown: this.hometown,
        serialNumber: this.serialNumber,
        page: this.page,
        areaNum: this.areaNum,
        selectedPersonalityTags: this.selectedPersonalityTags,
        selectedSpouseTags: this.selectedSpouseTags,
        personalityTagsText: this.personalityTagsText,
        spouseTagsText: this.spouseTagsText
      };
      const params = {
        sex: this.sex ? this.sex === '男' ? 1 : 2 : '',
        education: this.education && this.education !== '不限' ? this.educationFilterOptions.indexOf(this.education) : '',
        minimumBirthday: this.minimumBirthday ? new Date(this.minimumBirthday + '-01-01').toISOString() : '',
        maximumBirthday: this.maximumBirthday ? new Date(this.maximumBirthday + '-12-31').toISOString() : '',
        minimumHeight: this.minimumHeight,
        maximumHeight: this.maximumHeight,
        hometown: this.hometown,
        keyWord: this.serialNumber,
        page: this.page,
        pageSize: this.pageSize,
      };
      if (this.selectedPersonalityTags.length > 0) {
        params.personalityTagIds = this.selectedPersonalityTags;
      }
      if (this.selectedSpouseTags.length > 0) {
        params.spouseRequirementTagIds = this.selectedSpouseTags;
      }

      console.log(params)
      getMemberList(params).then(res => {
        if (res) {
          const neWInfoList = this.unique(this.$store.getters.infoList.concat(res.data.items));
          this.$store.dispatch('SetInfoList', neWInfoList);
          this.loading = false;
          if (neWInfoList.length >= res.data.total) {
            this.finished = true;
          } else {
            this.page++;
            this.$store.dispatch('SET_QueryList', queryList);
          }
        }
      });
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((item) => !res.has(item.id) && res.set(item.id, 1));
    },
    getUpdateTime(time) {
      if (time) {
        let birthYear = Number(time.slice(0, 4));
        let Y = new Date().getFullYear();
        return Y - birthYear;
      }
    },
    handleQuery() {
      this.page = 1;
      this.finished = false;
      const queryList = {
        sex: this.sex,
        education: this.education,
        minimumBirthday: this.minimumBirthday,
        maximumBirthday: this.maximumBirthday,
        minimumHeight: this.minimumHeight,
        maximumHeight: this.maximumHeight,
        hometown: this.hometown,
        serialNumber: this.serialNumber,
        page: this.page,
        areaNum: this.areaNum
      };
      this.$store.dispatch('SET_QueryList', queryList);
      const params = {
        sex: this.sex ? this.sex === '男' ? 1 : 2 : '',
        education: this.education && this.education !== '不限' ? this.educationFilterOptions.indexOf(this.education) : '',
        minimumBirthday: this.minimumBirthday ? new Date(this.minimumBirthday + '-01-01').toISOString() : '',
        maximumBirthday: this.maximumBirthday ? new Date(this.maximumBirthday + '-12-31').toISOString() : '',
        minimumHeight: this.minimumHeight,
        maximumHeight: this.maximumHeight,
        hometown: this.hometown,
        keyWord: this.serialNumber,
        page: this.page,
        pageSize: this.pageSize,
      };
      if (this.selectedPersonalityTags.length > 0) {
        params.personalityTagIds = this.selectedPersonalityTags;
      }
      if (this.selectedSpouseTags.length > 0) {
        params.spouseRequirementTagIds = this.selectedSpouseTags;
      }
      console.log(params)
      return getMemberList(params).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch('SetInfoList', res.data.items);
        }
      });
    },
    handlePopupQuery() {
      this.handleQuery();
      this.showSearchPopup = false;
    },
    formatSerial(serialNumber) {
      if (!serialNumber) return "0000";
      return String(serialNumber).padStart(4, "0");
    },
    async loadTags() {
      try {
        const res = await getAllTags();
        if (res.code === 20000) {
          // this.allTags = [{ id: '0', tagName: '不限', tagType: 1, sortOrder: 0, isSystem: false }];
          // this.allTags = this.allTags.concat(res.data || []);
          this.allTags = res.data || [];
          this.personalityTags = this.allTags;
          this.spouseTags = this.allTags;
        }
      } catch (error) {
        console.error("加载标签失败", error);
      }
    },
    showTagPicker(type) {
      this.currentTagType = type;
      switch (type) {
        case "personality":
          this.currentTagList = this.personalityTags;
          this.selectedTags = [...this.selectedPersonalityTags];
          break;
        case "spouse":
          this.currentTagList = this.spouseTags;
          this.selectedTags = [...this.selectedSpouseTags];
          break;
      }
      this.showTagPopup = true;
    },
    cancelTags() {
      this.showTagPopup = false;
      switch (this.currentTagType) {
        case "personality":
          this.selectedPersonalityTags = [];
          this.selectedTags = [];
          this.personalityTagsText = "";
          break;
        case "spouse":
          this.selectedSpouseTags = [];
          this.selectedTags = [];
          this.spouseTagsText = "";
          break;
      }
    },
    confirmTags() {
      this.showTagPopup = false;
      switch (this.currentTagType) {
        case "personality":
          this.selectedPersonalityTags = [...this.selectedTags];
          this.personalityTagsText = this.selectedPersonalityTags.length > 0 ? `已选${this.selectedPersonalityTags.length}项` : "";
          break;
        case "spouse":
          this.selectedSpouseTags = [...this.selectedTags];
          this.spouseTagsText = this.selectedSpouseTags.length > 0 ? `已选${this.selectedSpouseTags.length}项` : "";
          break;
      }
    },
    toggleTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
    },
  },
  created() {
    this.loadTags();
    const newData = [];
    for (let index = 140; index < 226; index++) {
      newData.push(index);
    }
    this.highColumns = [].concat(newData);
    const dateData = [];
    const newDate = new Date().getFullYear();
    for (let index = 1970; index < newDate; index++) {
      dateData.push(index);
    }
    this.dateData = dateData;
  },
};
</script>
<style scoped lang="less">
@import url('../../style/theme-variables.less');
@import url('../../style/prototype-common.less');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  position: relative;
  padding: 0.95rem 0.8rem 0;
}

.search-entry {
  .prototype-card();
  min-height: 2.7rem;
  padding: 0.78rem 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  margin-bottom: 0.85rem;
}

.search-entry-main {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .van-icon {
    flex-shrink: 0;
    font-size: 0.82rem;
    color: @text-tertiary;
  }
}

.search-entry-text {
  min-width: 0;
  flex: 1;
  font-size: 0.64rem;
  line-height: 0.92rem;
  color: @text-secondary;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-entry-action {
  flex-shrink: 0;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 138, 154, 0.12);
  font-size: 0.54rem;
  line-height: 0.78rem;
  color: @primary-color;
  font-weight: @font-weight-semibold;
}

/deep/ .van-list {
  padding-bottom: 0.2rem;
}

.content-info {
  width: 100%;
  min-height: 5.25rem;
  margin-top: 0.8rem;
  padding: 0.85rem 0.9rem;
  background: @bg-card;
  border-radius: @radius-large;
  box-shadow: @shadow-card;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  position: relative;

  .content-head {
    width: 3.35rem;
    height: 3.35rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: @shadow-avatar;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .content-detail {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;

    .detail-line1 {
      font-size: 0.72rem;
      font-weight: @font-weight-semibold;
      color: @text-primary;
      line-height: 1rem;
    }

    .detail-line2,
    .detail-line3 {
      font-size: 0.58rem;
      color: @text-secondary;
      line-height: 0.86rem;
      display: flex;
      justify-content: space-between;
      gap: 0.4rem;
    }

    .detail-line3 {
      align-items: center;
      justify-content: flex-start;
      gap: 0.35rem;

      .detail-line3-hometown {
        flex: 1 1 auto;
        min-width: 0;
        max-width: calc(100% - 3.4rem);
        display: flex;
        align-items: center;

        >span:last-child {
          flex: 1;
          min-width: 0;
          margin-left: 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .detail-line3-education {
        flex-shrink: 0;
        min-width: 3rem;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;

        >span:last-child {
          margin-left: 0.1rem;
          white-space: nowrap;
        }
      }
    }
  }

  .content-go {
    width: 0.7rem;
    height: 0.7rem;
    flex-shrink: 0;
    background: url('../../assets/btn_arrow_black_6x6.png') no-repeat center;
    background-size: 0.42rem 0.42rem;
    opacity: 0.55;

    span {
      width: 2.3rem;
      display: inline-block;
      height: 1rem;
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 @radius-large 0 0.55rem;
      background: @gradient-pink-v;
      font-size: 0.52rem;
      font-weight: @font-weight-bold;
      color: @text-light;
      text-align: center;
      line-height: 1rem;
      box-shadow: 0 6px 16px rgba(254, 181, 177, 0.24);
    }
  }
}

.search-popup {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
}

.search-popup-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #FFFFFF 0%, #FFF6F8 16%, #FFFFFF 100%);
}

.search-popup-header {
  padding: 1rem 0.9rem 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.popup-title {
  font-size: 1rem;
  line-height: 1.35rem;
  color: @text-primary;
  font-weight: @font-weight-bold;
}

.popup-close {
  width: 1.9rem;
  height: 1.9rem;
  border: none;
  border-radius: 0.7rem;
  background: @bg-gray;
  font-size: 0.95rem;
  color: @text-primary;
}

.search-popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 0.8rem 1rem;
}

.keyword-card {
  .prototype-card();
  padding: 0.85rem;
  margin-bottom: 0.8rem;
}

.keyword-label {
  font-size: 0.58rem;
  line-height: 0.84rem;
  color: @text-tertiary;
  margin-bottom: 0.55rem;
}

.keyword-field {
  width: 100%;
  height: 2.1rem;
  padding: 0 0.7rem;
  border-radius: 999px;
  background: @bg-gray;
  display: flex;
  align-items: center;
  gap: 0.45rem;

  .van-icon {
    flex-shrink: 0;
    font-size: 0.8rem;
    color: @text-tertiary;
  }

  input {
    width: 100%;
    border: none;
    background: transparent;
    font-size: 0.64rem;
    color: @text-primary;
    outline: none;
  }
}

.filter-section {
  .prototype-card();
  padding: 0.85rem;
  margin-bottom: 0.8rem;
}

.section-title {
  font-size: 0.74rem;
  line-height: 1rem;
  color: @text-primary;
  font-weight: @font-weight-bold;
  margin-bottom: 0.75rem;
}

.selector-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}

.selector-cell {
  min-height: 3.1rem;
  padding: 0.65rem 0.7rem;
  border-radius: @radius-large;
  background: @bg-gray;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.selector-label {
  font-size: 0.54rem;
  line-height: 0.78rem;
  color: @text-tertiary;
}

.selector-value {
  font-size: 0.64rem;
  line-height: 0.92rem;
  color: @text-primary;
  font-weight: @font-weight-medium;

  &.placeholder {
    color: @text-tertiary;
    font-weight: @font-weight-normal;
  }
}

.over-omit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-popup-footer {
  padding: 0.7rem 0.8rem calc(0.7rem + env(safe-area-inset-bottom));
  display: flex;
  gap: 0.65rem;
  background: #FFFFFF;
  box-shadow: 0 -6px 20px rgba(26, 26, 26, 0.06);
}

.footer-btn {
  flex: 1;
  height: 2rem;
  border: none;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: @font-weight-semibold;
}

.footer-btn-reset {
  background: @bg-gray;
  color: @text-secondary;
}

.footer-btn-confirm {
  background: @gradient-primary;
  color: @text-light;
  box-shadow: @shadow-btn;
}

.popup-area-title {
  font-size: 14px;
}

.picker-popup,
.area-popup {
  border-top-left-radius: @radius-large;
  border-top-right-radius: @radius-large;
}

.member-item {
  width: 100%;
  margin-bottom: 0.8rem;
  background: #FFFFFF;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  padding: 0.8rem;
  position: relative;
  box-shadow: @shadow-card;

  .member-avatar {
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    margin-right: 0.8rem;
    background: #f5f5f5;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.content-info {
  flex: 1;
  min-width: 0;


  .member-name {
    min-width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.3rem;

    .name {
      font-size: 0.7rem;
      font-weight: 500;
      color: #333333;
    }

    .serial {
      font-size: 0.56rem;
      color: #999999;
    }
  }
}

.tag-picker {
  background: #FFFFFF;
  height: 100%;
  display: flex;
  flex-direction: column;

  .tag-picker-header {
    display: flex;
    justify-content: space-between;
    padding: 0.8rem;
    border-bottom: 1px solid #F0F0F0;

    .title {
      font-size: 0.8rem;
      font-weight: 600;
      color: #333333;
    }

    span {
      font-size: 0.7rem;
      color: #A402F7;
    }
  }

  .tag-list {
    flex: 1;
    overflow-y: auto;
    padding: 0.8rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: flex-start;
    align-content: flex-start;

    .tag-item {
      padding: 0.4rem 0.8rem;
      background: #F5F5F5;
      border-radius: 0.8rem;
      font-size: 0.7rem;
      color: #666666;
      border: 1px solid transparent;

      &.selected {
        background: rgba(164, 2, 247, 0.1);
        color: #A402F7;
        border-color: #A402F7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matchmakerCenter/memberQuery.vue